/* ==========================================================================
   GSJ LOOK — shared controller for the shop-the-look hotspot tiles + panel.
   Drives BOTH the Get Inspired page and the inspired collection template.

   Per [data-gsj-look-root]:
     - builds a product registry from each tile's inline
       <script type="application/json" data-gsj-look-products="<handle>"> …
     - opens ONE shared slide-in panel (from gsj-look-panel.liquid) on any
       [data-stl-open] click, pre-selecting the clicked piece
     - flips floating dot sides that would overflow their tile (clampHotspots)
     - wires the coordinate helper readout when present

   ADD posts a real /cart/add form -> assets/gs-panels.js capture-phase intercept
   opens the cart drawer OVER the panel. window.GSJLook.refresh(root) re-scans a
   root after new tiles are appended (collection LOAD MORE). Event-driven only.
   ========================================================================== */
(function () {
  function initRoot(root) {
    if (!root || root.__gsjLookInit) return;
    root.__gsjLookInit = true;

    var registry = {};
    var wrap = root.querySelector('[data-stl-panelwrap]');
    var panel = wrap && wrap.querySelector('[data-stl-panel]');
    var scrim = wrap && wrap.querySelector('[data-stl-scrim]');
    var gridEl = wrap && wrap.querySelector('[data-stl-panel-grid]');
    var closeBtn = wrap && wrap.querySelector('[data-stl-close]');
    var lastFocus = null;

    function scanData() {
      root.querySelectorAll('[data-gsj-look-products]').forEach(function (s) {
        var h = s.getAttribute('data-gsj-look-products');
        if (!h || registry[h]) return;
        try { registry[h] = JSON.parse(s.textContent || '[]') || []; } catch (e) { registry[h] = []; }
      });
    }
    scanData();

    function makeCard(p, selected) {
      var card = document.createElement('div');
      card.className = 'stl-pcard' + (selected ? ' is-selected' : '');

      var well = document.createElement('a');
      well.className = 'stl-pcard__well'; well.href = p.url || '#';
      if (p.image) { var im = document.createElement('img'); im.src = p.image; im.loading = 'lazy'; im.alt = p.title || ''; well.appendChild(im); }
      card.appendChild(well);

      var body = document.createElement('div'); body.className = 'stl-pcard__body';
      var t = document.createElement('a'); t.className = 'stl-pcard__title'; t.href = p.url || '#'; t.textContent = (p.title || '').toUpperCase(); body.appendChild(t);
      if (p.karat) { var m = document.createElement('p'); m.className = 'stl-pcard__meta'; m.textContent = p.karat; body.appendChild(m); }
      var pr = document.createElement('p'); pr.className = 'stl-pcard__price'; pr.textContent = p.price || ''; body.appendChild(pr);

      // ADD: a real /cart/add form so the theme's capture-phase intercept
      // (assets/gs-panels.js) handles the add AND opens the cart drawer over us.
      var form = document.createElement('form'); form.className = 'stl-pcard__form'; form.action = '/cart/add'; form.method = 'post';
      var id = document.createElement('input'); id.type = 'hidden'; id.name = 'id'; id.value = p.variantId; form.appendChild(id);
      var qty = document.createElement('input'); qty.type = 'hidden'; qty.name = 'quantity'; qty.value = '1'; form.appendChild(qty);
      var add = document.createElement('button'); add.type = 'submit'; add.className = 'stl-padd';
      add.textContent = p.available === false ? 'Sold out' : 'Add';
      if (p.available === false) add.disabled = true;
      add.setAttribute('aria-label', (p.available === false ? 'Sold out: ' : 'Add to cart: ') + (p.title || ''));
      form.appendChild(add); body.appendChild(form);

      card.appendChild(body);
      return card;
    }

    function openPanel(handle, prodIdx) {
      if (!wrap) return;
      var products = registry[handle] || [];
      gridEl.innerHTML = '';
      if (!products.length) {
        var e = document.createElement('p'); e.className = 'stl-panel__empty'; e.textContent = 'No products linked yet.'; gridEl.appendChild(e);
      } else {
        products.forEach(function (p, i) { gridEl.appendChild(makeCard(p, i === prodIdx)); });
      }
      lastFocus = document.activeElement;
      wrap.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('stl-locked');
      gridEl.scrollTop = 0;
      if (prodIdx >= 0) {
        var sel = gridEl.querySelector('.stl-pcard.is-selected');
        if (sel) sel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
      (closeBtn || panel).focus();
    }

    function closePanel() {
      if (!wrap || !wrap.classList.contains('is-open')) return;
      wrap.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('stl-locked');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // Open from any dot or pill (data-look = the shop_look_image handle).
    root.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-stl-open]');
      if (!trig || !root.contains(trig)) return;
      e.preventDefault();
      var pi = trig.getAttribute('data-product-index');
      openPanel(trig.getAttribute('data-look'), pi === null ? -1 : parseInt(pi, 10));
    });

    if (scrim) scrim.addEventListener('click', closePanel);
    if (closeBtn) closeBtn.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });

    // Keep every floating bubble on its tile: if a bubble would overflow, flip
    // its side to the opposite (the stem still terminates at the true point).
    function setSide(hs, side) {
      hs.classList.remove('is-up', 'is-down', 'is-left', 'is-right', 'is-center');
      hs.classList.add('is-' + side);
    }
    function clampHotspots() {
      root.querySelectorAll('.stl-tile').forEach(function (tile) {
        var tr = tile.getBoundingClientRect();
        if (!tr.width) return;
        tile.querySelectorAll('.stl-hotspot').forEach(function (hs) {
          var intended = hs.getAttribute('data-side') || 'auto';
          setSide(hs, intended);                       // reset to intended, then test
          if (intended === 'center') return;
          var dot = hs.querySelector('.stl-dot'); if (!dot) return;
          var dr = dot.getBoundingClientRect(), side = intended, pad = 2;
          if (dr.left < tr.left + pad) side = 'right';
          else if (dr.right > tr.right - pad) side = 'left';
          if (dr.top < tr.top + pad) side = 'down';
          else if (dr.bottom > tr.bottom - pad) side = 'up';
          if (side !== intended) setSide(hs, side);
        });
      });
    }

    // Coordinate helper: live "x%, y%" readout as the mouse moves over an image.
    function wireCoord() {
      root.querySelectorAll('.stl-tile').forEach(function (tile) {
        var badge = tile.querySelector('.stl-coord');
        if (!badge || badge.__wired) return;
        badge.__wired = true;
        tile.addEventListener('mousemove', function (ev) {
          var r = tile.getBoundingClientRect();
          if (!r.width || !r.height) return;
          badge.textContent = ((ev.clientX - r.left) / r.width * 100).toFixed(1) + '% , ' + ((ev.clientY - r.top) / r.height * 100).toFixed(1) + '%';
        });
      });
    }

    root.__gsjLookClamp = clampHotspots;
    root.__gsjLookScan = function () { scanData(); wireCoord(); clampHotspots(); };

    clampHotspots();
    wireCoord();
    window.addEventListener('load', clampHotspots);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(clampHotspots, 150); });
  }

  function initAll() {
    document.querySelectorAll('[data-gsj-look-root]').forEach(initRoot);
  }

  // Public hook: re-scan a root after new tiles are appended (LOAD MORE).
  window.GSJLook = {
    refresh: function (root) {
      if (root && root.__gsjLookScan) root.__gsjLookScan();
      else initAll();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
